import { render, staticRenderFns } from "./financialcompensation.vue?vue&type=template&id=862f0580&scoped=true&"
import script from "./financialcompensation.vue?vue&type=script&lang=js&"
export * from "./financialcompensation.vue?vue&type=script&lang=js&"
import style0 from "./financialcompensation.vue?vue&type=style&index=0&id=862f0580&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "862f0580",
  null
  
)

export default component.exports